import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_BASE_URL, ApprovalUserRole, FileParameter } from '@fdm/api-client';
import { of, tap } from 'rxjs';

export interface CreateAINotePayload {
  title: string;
  text: string;
  files?: FileParameter[];
}

@Injectable()
export class ActionItemCreateApiService {
  private _http = inject(HttpClient);

  private _baseUrl = inject(API_BASE_URL);

  private _url = this._baseUrl + '/api/ActionItem';

  public createNote(id: number, payload: CreateAINotePayload) {
    const formData = new FormData();

    formData.append('title', payload.title);

    if (!payload.text) {
      throw new globalThis.Error("The parameter 'text' cannot be null.");
    } else {
      formData.append('text', payload.text);
    }

    if (payload.files?.length) {
      payload.files.forEach((file) => {
        formData.append(
          `files`,
          file.data,
          file.fileName ? file.fileName : 'file',
        );
      });
    }

    return this._http.post(`${this._url}/${id}/notes`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  public delete(noteId: number) {
    // let url_ = this.baseUrl + "/api/ActionItem/notes/{noteId}";

    return this._http.delete<number>(`${this._url}/notes/${noteId}?approvalUserRole=${ApprovalUserRole.ActionItemOwner}`)
  }

  // TODO
  public download(blobName: string, noteId: number) {
    return this._http
      .get(`${this._url}/attachments/${noteId}/download`, {
        responseType: 'blob',
      })
      .pipe(tap((blob) => this._processDownloading(blobName, blob)));
  }

  private _processDownloading(fileName: string, blob: Blob) {
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(objectUrl);
  }
}
